<nav role="navigation">
    <button
        class="menu-button"
        (click)="handleMenuClick()"
        aria-controls="menu"
        [attr.aria-expanded]="(siteStateService.state$ | async)?.mobileMenu"
    >
        <span class="menu-icon-wrapper">
            <app-svg-icon
                aria-hidden="true"
                iconName="menu"
                class="icon-menu"
                *ngIf="!(siteStateService.state$ | async)?.mobileMenu"
            ></app-svg-icon>
            <app-svg-icon
                aria-hidden="true"
                iconName="close"
                class="icon-close"
                *ngIf="(siteStateService.state$ | async)?.mobileMenu"
            ></app-svg-icon>
        </span>
        <span class="kk-visuallyhidden">
            {{
                (siteStateService.state$ | async)?.mobileMenu
                    ? ('mobileMenu.closeMenu' | translateSafe)
                    : ('mobileMenu.openMenu' | translateSafe)
            }}
        </span>
    </button>
    <div
        id="menu"
        class="root"
        @rootSlide
        *ngIf="(siteStateService.state$ | async)?.mobileMenu"
        [style]="{
            top: topPosition() + 'px'
        }"
    >
        <div class="menu-level" *ngIf="activeRootList === null" @rootSlide>
            <app-mobile-root-list
                (setRootList)="activeRootList = $event"
                [menuGroups]="menuGroups"
                [metaMenuItems]="metaMenuItems"
            ></app-mobile-root-list>
            <div class="meta-menu-list" *ngIf="metaMenuItems">
                <app-mobile-meta-menu [metaMenuItems]="metaMenuItems"></app-mobile-meta-menu>
            </div>
        </div>
        <div id="subList" class="menu-level sub-list" *ngIf="activeRootList?.children as sublists" @subSlide>
            <button class="back-button" (click)="activeRootList = null" [appAutoFocus]="true">
                <span class="back-icon-wrapper">
                    <app-svg-icon iconName="chevron_left"></app-svg-icon>
                </span>
                {{ activeRootList?.name }}
            </button>
            <div class="sub-list-content">
                <app-mobile-sub-list [subLists]="sublists"></app-mobile-sub-list>
                <div class="sub-link">
                    <app-link *ngIf="activeRootList?.link as link" [link]="link">
                        {{
                            'mobileMenu.additionalLinkText'
                                | translateSafe: { category: link!.name || activeRootList!.name }
                        }}
                    </app-link>
                </div>
            </div>
            <div class="meta-menu-list" *ngIf="metaMenuItems">
                <app-mobile-meta-menu [metaMenuItems]="metaMenuItems"></app-mobile-meta-menu>
            </div>
        </div>
    </div>
</nav>
